<h2 class="screen-reader-only" id="headereLogin">{{ 'label.login' | translate }}</h2>
@if (isPasswordGrantAvailable()) {
  <form (submit)="submitLogin()" [attr.aria-label]="'a11y.login.form' | translate" [formGroup]="loginForm()">
    <portal-username-input formControlName="personalNumber" />
    <portal-password-input formControlName="password" />
    <p class="password-forgotten-link">
      <a routerLink="/passwort-vergessen"> {{ 'login_page.label.passwort_forgotten' | translate }}</a>
    </p>
    <button color="primary" mat-flat-button type="submit">
      {{ 'label.login' | translate }}
    </button>
  </form>

  @if (failedLoginInfo()) {
    <div class="login-error">
      <ebeihilfe-note type="danger" [messageText]="failedLoginInfo().error" />
    </div>
  }
}
@if (isExternalLoginEnabled()) {
  <div>
    @if (isPasswordGrantAvailable()) {
      <hr />
    }
    <button color="primary" mat-flat-button type="button" (click)="loginWithCodeFlow()">
      {{ 'label.externalLogin' | translate }}
    </button>
  </div>
}
